<template>
  <div class="card-content">
    <div class="content is-small">
      <h3>Steuerung</h3>
      <ul>
        <li>Linksklick + Ziehen: Neues Türchen erstellen</li>
        <li>Rechtsklick + Ziehen: Türchen verschieben</li>
        <li>Doppel- oder Mittelklick: Türchen löschen</li>
      </ul>
    </div>
    <figure class="image is-unselectable">
      <img :src="unwrap_loading(store.background_image).data_url" />
      <DoorCanvas v-model="model" />
    </figure>
  </div>
</template>

<script setup lang="ts">
import { type VueLike, unwrap_loading } from "@/lib/helpers";
import { Door } from "@/lib/rects/door";
import { advent22Store } from "@/lib/store";

import DoorCanvas from "./DoorCanvas.vue";

const model = defineModel<VueLike<Door>[]>({ required: true });
const store = advent22Store();
</script>
